import { atom } from 'jotai'

/**
 * 作成直後の配送依頼カードをハイライト表示するためのID
 * Drawerが閉じている間も保持するため、Atomで管理する（#4570）
 */
export const highlightedShipmentOrderIdAtom = atom<number | null>(null)

highlightedShipmentOrderIdAtom.debugLabel = 'highlightedShipmentOrderIdAtom'
